import { createContext } from 'react';
import { IReverbContext } from './models/IReverbContext.ts';

export const ReverbContext = createContext<IReverbContext>({
    echo: null,
});